export const getServiceProcedureFrag = `
    id
    customCode
    code
    customName
    frequency
    courseDescription
    textTemplate
    color
    procedure {
        description
    }
`;

export const getServiceOperationalCapacityFrag = `
    id
`;
